"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Apps = void 0;
class Apps {
    static AppTitle;
    static AppTypes;
}
exports.Apps = Apps;
(function (Apps) {
    let titles;
    (function (titles) {
        titles["crossmark"] = "crossmark";
        titles["embark"] = "embark";
    })(titles = Apps.titles || (Apps.titles = {}));
})(Apps || (exports.Apps = Apps = {}));
//# sourceMappingURL=index.js.map